import { ObituaryResponse } from "./type";

/**
 * 특정 부고에만 하단 Fixed 3-버튼(부의금/근조화환/부고전달) + 중앙 3-버튼 박스 숨김
 * 레이아웃을 적용하기 위한 화이트리스트.
 *
 * 기존 사용자 컴플레인 대응으로 부고 단위로 점진 적용 중이며, 조건이 일치하는
 * 부고에만 신규 레이아웃을 노출한다. 확장이 필요하면 배열에 항목 추가.
 *
 * passed_away_on은 optional. 지정하면 그 값까지 매칭하고,
 * 생략하면 name/age만 일치해도 매칭 (dev 테스트 편의).
 * 프로덕션 부고는 name/age/passed_away_on 세 필드 모두 지정 권장.
 */
const TARGET_OBITUARIES_FOR_VISITOR_FIXED_FOOTER_VARIANT: {
  name: string;
  age: number;
  passed_away_on?: string;
}[] = [
  { name: "박순자", age: 104, passed_away_on: "2026-07-02" },
  { name: "누구냐넌", age: 30 },
];

export const isTargetObituaryForVisitorFixedFooterVariant = (
  obituary:
    | Pick<ObituaryResponse, "name" | "age" | "passed_away_on">
    | undefined
    | null
): boolean => {
  if (!obituary) return false;
  return TARGET_OBITUARIES_FOR_VISITOR_FIXED_FOOTER_VARIANT.some(
    (target) =>
      obituary.name === target.name &&
      obituary.age === target.age &&
      (target.passed_away_on === undefined ||
        obituary.passed_away_on === target.passed_away_on)
  );
};

/**
 * 화환 주문 비활성 사유.
 * - "no_binso": 장례식장/빈소 정보 미입력
 * - "owner_disabled": 작성자가 is_wreath_order_acceptable=false로 직접 비활성
 * - null: 활성 (제약 없음)
 */
export type FlowerOrderDisabledReason = "no_binso" | "owner_disabled" | null;

export const FLOWER_ORDER_DISABLED_MESSAGE: Record<
  Exclude<FlowerOrderDisabledReason, null>,
  string
> = {
  no_binso: "장례식장 빈소 정보를 확인해주세요",
  owner_disabled: "이 부고는 화환을 받지 않습니다",
};

/**
 * 화환 주문 비활성 사유 판정.
 * is_wreath_order_acceptable === false (작성자 토글 off)가 빈소 정보 부족보다 우선.
 * 사유 메시지가 명확하고 작성자가 명시적으로 끈 의도를 존중.
 */
export const getFlowerOrderDisabledReason = (
  obituary:
    | Pick<ObituaryResponse, "parlor" | "binso" | "is_wreath_order_acceptable">
    | undefined
    | null
): FlowerOrderDisabledReason => {
  if (!obituary) return "no_binso";
  if (obituary.is_wreath_order_acceptable === false) return "owner_disabled";
  if (!obituary.parlor?.companyname || !obituary.binso) return "no_binso";
  return null;
};

export const getIsFlowerOrderEnabled = (
  obituary:
    | Pick<ObituaryResponse, "parlor" | "binso" | "is_wreath_order_acceptable">
    | undefined
    | null
): boolean => getFlowerOrderDisabledReason(obituary) === null;
